import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';

import {MenuItem as FeUiMenuItem} from '@spothero/ui';

const menuItemStyles = {
    paddingX: 4,
    paddingY: 2.5,
};

const menuLinkExternalProps = {
    as: 'a',
    target: '_blank',
    rel: 'noopener noreferrer',
};

const MenuItem = forwardRef(({isExternal, ...props}, ref) => {
    const {as, href} = props;

    return (
        <FeUiMenuItem
            ref={ref}
            {...menuItemStyles}
            {...(isExternal && as === 'a' && {...menuLinkExternalProps, href})}
            {...props}
        />
    );
});

MenuItem.propTypes = {
    isExternal: PropTypes.bool,
    as: PropTypes.string,
    href: PropTypes.string,
};

export default MenuItem;
